<template>
  <div>
    <!-- 我的考勤 -->
    <div class="box-margin">
      <Card>
        <Form :model="formItem" :label-width="85" label-position="left" :disabled="prevent" ref="formValidate" :rules="ruleValidate" :show-message="false">
          <Row style="margin-bottom: 0">
            <Col span="5">
              <FormItem :label="$t('diligent.years')" prop="years">
                <DatePicker type="month" v-model="formItem.years" clearable="" :editable="false"></DatePicker>
              </FormItem>
            </Col>
            <Col span="1" offset="1">
               <!--  @click="mainSearch(),pageInfo.pageNo = 1,pageInfo.itemCount = 0"  -->
               <!-- <Button type="primary">查询</Button> -->
            </Col>
          </Row>
        </Form>
      </Card>
      <Table border :columns="columns1" :data="data1" :loading="modal_loading" >
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" @click="exportHandler(row)">导出</Button>
        </template>
      </Table>
      <Page style="margin-top: 20px; display: flex; justify-content: flex-end" @on-change="pageChange" :total="pageInfo.itemCount"
      />
    </div>
    <div>
      <Modal v-model="PrintPop" width="60%" @on-ok="getPdf($t('overtimeDetail.ygqdjlyctzd'))">
          <!--startprint-->
          <div id="pdfDom" style="padding: 0px 30px;font-size: 18px;padding-top: 55px;background-color:#fff;color: #000;" ref="exportPdf">
          <div class="PrintPop_TAL" >{{$t('diligentquery.ECN')}}</div>  
          <div class="PrintPop_TBOLANDTAL" >{{$t('overtimeDetail.ygqdjlyctzd')}}</div>          
          <div style="width: 90%;margin: auto;border: 2px solid #000;border-bottom: none;">
              <div class="PrintPop_Row" >
                <div class="PrintPop_TBOLANDTAL" style="width: calc(100%/6)">{{$t('diligentquery.serviceUnit')}}</div>
                <div class="PrintPop_BORLEF PrintPop_PLEF" style="flex: 6;"><!--{{$t('diligentquery.shfgsyybbmkyz')}}-->{{PrintItem.cnorgcode456}}</div>
              </div>
              <div class="PrintPop_Row" >
                <div class="PrintPop_TBOLANDTAL" style="width: calc(100%/6);">{{$t('educationalInformation.personnelCode')}}</div>
                <div class="PrintPop_BORLEF PrintPop_PLEF" style="width: calc(100%/6)">{{PrintItem.empcode}}</div>
                <div class="PrintPop_TBOLANDTAL PrintPop_BORLEF  " style="width: calc(100%/6)">{{$t('educationalInformation.name')}}</div>
                <div class="PrintPop_BORLEF PrintPop_PLEF" style="width: calc(100%/6)">{{PrintItem.user_name}}</div>
                <div class="PrintPop_TBOLANDTAL PrintPop_BORLEF  " style="width: calc(100%/6)">{{$t('educationalInformation.position')}}</div>
                <div class="PrintPop_BORLEF PrintPop_PLEF" style="width: calc(100%/6)">{{PrintItem.pos_c_name}}</div>
              </div>
              <div class="PrintPop_null"></div>
              <div class="PrintPop_content">
                  <div class="PrintPop_content_left" style="width: calc(100%/6)">{{$t('diligentquery.subjectMatter')}}</div>
                  <div class="PrintPop_content_right" style="flex: 6;">
                    <div style="margin-top: 10px;margin-left: 30px;display: flex;flex-wrap: wrap;">
                      <div class="PrintPop_content_sy_left"> 
                        {{$t('diligentquery.one')}}<span class="PrintPop_spanItem" >{{PrintItem.YY}}</span>{{$t('diligentquery.annualEnd')}}<span class="PrintPop_spanItem">{{PrintItem.MM}}</span>{{$t('diligentquery.ytdy')}}
                      </div>
                      <div class="PrintPop_content_sy_right"> 
                        {{$t('diligentquery.ForgettingToPunchTheWorkCard')}}<span class="PrintPop_spanItem">{{PrintItem.atp}}</span>{{$t('educationalInformation.second')}}
                      </div>
                      <div class="PrintPop_content_sy_left"></div>
                      <div class="PrintPop_content_sy_right"> 
                        {{$t('diligentquery.ForgettingToPunchOffDutyCard')}}<span class="PrintPop_spanItem">{{PrintItem.atq}}</span>{{$t('educationalInformation.second')}}
                      </div>
                      <div class="PrintPop_content_sy_left"></div>
                      <div class="PrintPop_content_sy_right"> 
                        <span style="letter-spacing: 53px;margin-right: -51px;">{{$t('educationalInformation.late')}}</span><span class="PrintPop_spanItem">{{PrintItem.atl}}</span><span>{{$t('educationalInformation.second')}}</span>
                        <span class="PrintPop_spanItem">{{PrintItem.atlt}}</span><span>{{$t('educationalInformation.minute')}}</span>
                      </div>
                      <div class="PrintPop_content_sy_left"></div>
                      <div class="PrintPop_content_sy_right">
                        <span style="letter-spacing: 53px;margin-right: -51px;">{{$t('educationalInformation.leaveEarly')}}</span><span class="PrintPop_spanItem">{{PrintItem.ate}}</span><span>{{$t('educationalInformation.second')}}</span>
                        <span class="PrintPop_spanItem">{{PrintItem.atpet}}</span><span>{{$t('educationalInformation.minute')}}</span>
                      </div>
                      <div class="PrintPop_content_sy_left"></div>
                      <div class="PrintPop_content_sy_right"> 
                        <span style="letter-spacing: 17px;margin-right: -14px;">{{$t('diligentquery.qsj')}}</span><span class="PrintPop_spanItem">{{PrintItem.lvatms}}</span><span>{{$t('educationalInformation.second')}}</span>
                        <span class="PrintPop_spanItem">{{PrintItem.lvahs}}</span><span>{{$t('educationalInformation.hour')}}</span>
                      </div>
                      <div class="PrintPop_content_sy_left"></div>
                      <div class="PrintPop_content_sy_right"> 
                        <span style="letter-spacing: 17px;margin-right: -14px;">{{$t('diligentquery.qbj')}}</span><span class="PrintPop_spanItem">{{PrintItem.lvstms}}</span><span>{{$t('educationalInformation.second')}}</span>
                        <span class="PrintPop_spanItem">{{PrintItem.lvshs}}</span><span>{{$t('educationalInformation.hour')}}</span>
                      </div>
                    </div>
                    <div style="margin-top: 10px;margin-left: 30px;">
                      <div style="width: 77%;"> 
                        {{$t('quitApproval.two')}}{{$t('diligentquery.qdjlyggrkqqtrtsgl')}}
                      </div>
                    </div>
                  
                  </div>
              </div>
              <div class="PrintPop_null"></div>
              <div class="PrintPop_content">
                  <div class="PrintPop_content_left" style="width: calc(100%/6)">{{$t('diligentquery.exceptionRecordDetails')}}</div>
                  <div class="PrintPop_content_right" style="flex: 6;">
                      <div class="PrintPop_content_Top">
                          <div class="PrintPop_content_Top_content">
                            <div class="PrintPop_TBOL">1.{{$t('diligentquery.ForgettingToPunchTheWorkCard')}}</div>
                            <div v-for="(item,index) in wsbList" :key="index" class="PrintPop_content_Top_content_item">{{date.dateVal(item.begintime, "YYYY/MM/DD") || ''}}</div>
                          </div>
                          <div class="PrintPop_content_Top_content">
                            <div class="PrintPop_TBOL">2.{{$t('diligentquery.ForgettingToPunchOffDutyCard')}}</div>
                            <div v-for="(item,index) in wxbList" :key="index" class="PrintPop_content_Top_content_item">{{date.dateVal(item.begintime, "YYYY/MM/DD") || ''}}</div>
                          </div>
                          <div class="PrintPop_content_Top_content">
                            <div class="PrintPop_TBOL">3.{{$t('educationalInformation.late')}}</div>
                            <div v-for="(item,index) in cdList" :key="index" class="PrintPop_content_Top_content_item">{{date.dateVal(item.begintime, "YYYY/MM/DD") || ''}}</div>
                          </div>
                          <div class="PrintPop_content_Top_content">
                            <div class="PrintPop_TBOL">4.{{$t('educationalInformation.leaveEarly')}}</div>
                            <div v-for="(item,index) in ztList" :key="index" class="PrintPop_content_Top_content_item">{{date.dateVal(item.begintime, "YYYY/MM/DD") || ''}}</div>
                          </div>
                      </div>
                      <div class="PrintPop_content_Top">
                        <div class="PrintPop_content_Bot_content">
                          <div class="PrintPop_TBOL">5.{{$t('educationalInformation.compassionateLeave')}}</div>
                          <div v-for="(item,index) in sjList" :key="index" class="PrintPop_content_Bot_content_item">{{date.dateVal(item.begintime, "YYYY/MM/DD") || ''}}-{{date.dateVal(item.endtime, "YYYY/MM/DD") || ''}}<span class="PrintPop_spanItem">{{item.leavetime}}</span>{{$t('educationalInformation.Time')}}</div>
                        </div>
                        <div class="PrintPop_content_Bot_content">
                          <div class="PrintPop_TBOL">6.{{$t('ContractRenewalApply.sickLeave')}}</div>
                          <div v-for="(item,index) in bjList" :key="index" class="PrintPop_content_Bot_content_item">{{date.dateVal(item.begintime, "YYYY/MM/DD") || ''}}-{{date.dateVal(item.endtime, "YYYY/MM/DD") || ''}}<span class="PrintPop_spanItem">{{item.leavetime}}</span>{{$t('educationalInformation.Time')}}</div>
                        </div>
                    </div>
                  </div>
              </div>
              <div class="PrintPop_null"></div>
              <div class="PrintPop_Row" >
                <div class="PrintPop_TBOLANDTAL" style="width: calc(100%/6)">{{$t('diligentquery.tjqj')}}</div>
                <div class="PrintPop_BORLEF PrintPop_PLEF" style="flex: 6;">{{$t('diligentquery.qyn12y1rzdn11y30r')}}</div>
              </div>
              <div class="PrintPop_null"></div>
              <div class="PrintPop_Row">
                <div class="PrintPop_TBOLANDTAL" style="width: calc(100%/6)">{{$t('diligentquery.cbyz')}}</div>
                <div class="PrintPop_BORLEF PrintPop_PLEF" style="flex: 6;">{{$t('diligentquery.grqdjlddrsxzxtnxggdzryxbs')}}</div>
              </div>
            </div>
          </div>
          <!--endprint-->
      </Modal>
    </div>
  </div>
</template>
<script>
import DateUtil from "../../../util/DateUtil";
import ModelUtils from "../../../util/ModelUtil";
import axios from "axios";
export default {
  data() {
    return {
      PrintItem: {},
      formItem: {},
      filter: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      totalNum: 0,
      prevent: false,
      modal_loading: false,
      config: false,
      PrintPop: false,
      titleText: this.$t("share.selectPeople"),
      date: new DateUtil(),
      columns1: [
        {
          title: "员工工号",
          key: "emp_code",
          width: 100,
          align: "center",
        },
        {
          title: "姓名",
          key: "user_name",
          width: 100,
          align: "center",
        },
        {
          title: "公司",
          key: "orgsname2",
          width: 100,
          align: "center",
        },
        {
          title: "地区",
          key: "orgsname4",
          width: 100,
          align: "center",
        },
        {
          title: "职位",
          key: "position_name",
          width: 150,
          align: "center",
        },
        {
          title: "薪资结算月",
          key: "MM",
          align: "center",
          width: "120",
        },
        {
          title: "缺勤统计区间",
          align: "center",
          children: [
            {
              title: "事假",
              align: "center",
              children: [
                {
                  title: "次数",
                  key: "lvatms",
                  align: "center",
                  width: "85"
                },
                {
                  title: "时数",
                  key: "lvahs",
                  align: "center",
                  width: "85"
                },
              ],
            },
            {
              title: "病假",
              align: "center",
              children: [
                {
                  title: "次数",
                  key: "lvstms",
                  align: "center",
                  width: "85"
                },
                {
                  title: "时数",
                  key: "lvshs",
                  align: "center",
                  width: "85"
                },
              ],
            },
            {
              title: "迟到",
              align: "center",
              children: [
                {
                  title: "次数",
                  key: "atl",
                  align: "center",
                  width: "85"
                },
                {
                  title: "分数",
                  key: "atlt",
                  align: "center",
                  width: "85"
                },
              ],
            },
            {
              title: "早退",
              align: "center",
              children: [
                {
                  title: "次数",
                  key: "ate",
                  align: "center",
                  width: "85"
                },
                {
                  title: "分数",
                  key: "atpet",
                  align: "center",
                  width: "85"
                },
              ],
            },
            {
              title: "忘打上班卡",
              align: "center",
              children: [
                {
                  title: "次数",
                  key: "atp",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "忘打下班卡",
              align: "center",
              children: [
                {
                  title: "次数",
                  key: "atq",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "通知单",
          slot: "action",
          align: "center",
          fixed: "right",
          width: "100",
        },
      ],
      data1: [],
      columns2: [
        {
          title: this.$t("educationalInformation.personnelCode"),
          align: "center",
          key: "emp_code",
        },
        {
          title: this.$t("educationalInformation.name"),
          align: "center",
          key: "user_name",
        },
        {
          title: this.$t("educationalInformation.company"),
          align: "center",
          key: "orgsname2",
        },
        {
          title: this.$t("educationalInformation.district"),
          align: "center",
          key: "orgsname4",
        },
        {
          title: this.$t("formalTrialApproval.ministry"),
          align: "center",
          key: "orgsname5",
        },
        {
          title: this.$t("educationalInformation.lesson"),
          align: "center",
          key: "orgsname6",
        },
        {
          title: this.$t("OvertimeModificationApply.group"),
          align: "center",
          key: "orgsname6",
        },
        {
          title: this.$t("share.Choice"),
          slot: "action",
          width: 150,
          align: "center",
        },
      ],
      data2: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
      },
      ruleValidate: {
        years: [
          {
            required: true,
            message: "请选择年份",
          },
        ],
      },
      wsbList: [],
      wxbList: [],
      cdList: [],
      ztList: [],
      sjList: [],
      bjList: [],
    };
  },
  watch: {},
  mounted() {
    // this.mainSearch();
  },
  methods: {
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.mainSearch();
    },
    printPDf() {
      this.$nextTick(() => {
        this.$PDFSave(
          this.$refs.exportPdf,
          this.$t("overtimeDetail.ygqdjlyctzd")
        );
      });
    },
    // 主頁面查詢功能
    mainSearch() {
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          this.modal_loading = true;
          this.prevent = true;
          this.formItem.empcode = JSON.parse(
            window.sessionStorage.getItem("userInfo")
          ).loginUserId;
          this.formItem.years = this.date.dateVal(
            this.formItem.years,
            "YYYY-MM-DD"
          );
          let arr = [
            {
              type: "CKQinduo",
              stringData4: "2",
              stringData5: "4",
              objData1: { ...this.formItem },
              objData2: { pageNo: this.pageInfo.pageNo },
              // stringData3: "1",
            },
          ];
          axios.post("/api/process/execute", arr).then((res) => {
            this.modal_loading = false;
            this.prevent = false;
            this.data1 = res[0].dataList;
            this.pageInfo = res[0].pageInfo;
          });
        }
      });
    },
    exportHandler(row) {
      this.PrintPop = true;
      this.PrintItem = row;
      // this.getPrintData();
    },
    getPrintData() {
      let arr = [
        {
          type: "CKQinduo",
          stringData4: "2",
          stringData5: "5",
          objData1: {
            empcode: this.PrintItem.empcode,
            stdate: this.PrintItem.stdate
              ? this.date.dateVal(this.PrintItem.stdate, "YYYY-MM-DD HH:mm")
              : "",
            eddate: this.PrintItem.eddate
              ? this.date.dateVal(
                  new Date(this.PrintItem.eddate).setDate(
                    new Date(this.PrintItem.eddate).getDate() + 1
                  ),
                  "YYYY-MM-DD HH:mm"
                )
              : "",
          },
          // stringData3: "2",
        },
      ];
      axios.post("/api/process/execute", arr).then((res) => {
        this.printDataList = res[0];
        this.wsbList = [];
        this.wzbList = [];
        this.sjList = [];
        this.ztList = [];
        this.cdList = [];
        this.bjList = [];

        this.printDataList.map((item) => {
          //事假
          if (item.leavetype == "A") {
            this.sjList.push(item);
          }
          //早退
          if (item.leavetype == "AT_E") {
            this.ztList.push(item);
          }
          //遲到
          if (item.leavetype == "AT_L") {
            this.cdList.push(item);
          }
          //忘打上班卡
          if (item.leavetype == "AT_P") {
            this.wsbList.push(item);
          }
          //忘打下班卡
          if (item.leavetype == "AT_Q") {
            this.wxbList.push(item);
          }
          //病假
          if (item.leavetype == "S01") {
            this.bjList.push(item);
          }
        });
      });
    },
  },
};
</script>
<style  scoped>
.main {
  padding: 2%;
  font-family: Simsun;
}
@media print {
  @page {
    size: A4;
  }
}
@media screen {
  .main {
    display: none;
  }
}
.PrintPop_spanItem {
  width: 50px;
  display: inline-block;
  text-align: center;
}
.PrintPop_TAL {
  text-align: center;
}
.PrintPop_TBOL {
  font-weight: bold;
}
.PrintPop_Row {
  display: flex;
  line-height: 45px;
  border-bottom: 2px solid #000;
}
.PrintPop_TBOLANDTAL {
  text-align: center;
  font-weight: bold;
}
.PrintPop_BORLEF {
  border-left: 2px solid #000;
}
.PrintPop_PLEF {
  padding-left: 10px;
}
.PrintPop_null {
  padding: 5px;
  border-bottom: 2px solid #000;
}
.PrintPop_content {
  border-bottom: 2px solid #000;
  display: flex;
}
.PrintPop_content_left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  writing-mode: vertical-lr;
  letter-spacing: 50px;
  padding-bottom: 50px;
  padding-top: 50px;
  font-weight: bold;
}
.PrintPop_content_right {
  border-left: 2px solid #000;
}
.PrintPop_content_Top {
  width: 92%;
  /* height: 50%; */
  display: flex;
  margin: 10px auto;
}
.PrintPop_content_Top_content {
  width: calc(100% / 4);
  text-align: center;
}
.PrintPop_content_Bot_content {
  width: calc(100% / 2);
  text-align: center;
}
.PrintPop_content_Top_content_item {
  text-align: center;
}
.PrintPop_content_sy_left {
  text-align: left;
  width: 42%;
  margin-right: 10px;
}
.PrintPop_content_sy_left::after {
  content: "_";
  float: right;
}
.PrintPop_content_sy_right {
  margin-left: 10px;
  width: 40%;
}
.box-margin {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/MyQuery/EmoloyeeAttendance.vue